import React from "react";
import styled from "styled-components";
import Color from "../../assets/Colors";
import {Link} from "react-router-dom";

export default function CookiesWarn() {
   return (
      <>
         <TitleStyled>POLITICA DE COOKIES </TitleStyled>
         <TextStyled>Queremos informarle de manera clara y precisa sobre las cookies que utilizamos, detallando a continuación:</TextStyled>
         <TextStyled>
            <li> 1) qué es una cookie</li>
            <li>2) para qué sirve</li>
            <li>3) Finalidad de las cookies</li>
            <li>4) ¿cómo deshabilitar la utilización de las cookies y eliminar las instaladas?</li>
            <li>5) qué tipo de cookies utilizamos</li>
         </TextStyled>
         <SubtitleStyled>1. ¿Qué son las cookies?</SubtitleStyled>
         <TextStyled>
            Una cookie es un <b>paquete de datos que un navegador web almacena</b> de forma automática en el ordenador de un usuario cuando
            éste visita una página web. La cookie es enviada desde el servidor al visitante de la página web.
         </TextStyled>
         <SubtitleStyled>2. ¿Para qué sirve una cookie?</SubtitleStyled>
         <TextStyled>
            Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de
            un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden
            utilizarse para reconocer al usuario.
            <br />
            <br />
            Su propósito principal es <b>identificar al usuario almacenando su historial de actividad en un sitio web específico</b>, de
            manera que se le pueda ofrecer el contenido más apropiado según sus hábitos.
            <br />
            <br />
            Las cookies son esenciales para el funcionamiento de internet, aportando innumerables ventajas en la prestación de servicios
            interactivos, facilitándole la navegación y usabilidad de nuestra web. En ningún caso las cookies podrían dañar su equipo. Por
            contra, el que estén activas nos ayuda a identificar y resolver los errores.
         </TextStyled>
         <SubtitleStyled>3. Finalidad de las cookies:</SubtitleStyled>
         <TextStyled>
            Las cookies pueden recabar información sobre sus visitas a nuestro Sitio Web, la frecuencia y duración de las mismas, las
            páginas visionadas y el tiempo que ha estado en nuestro Sitio Web. <br /> <br /> Le informamos de que podemos utilizar cookies
            con la finalidad de: <br />
            <br />
            <li className="list">Identificar problemas para mejorar nuestro Sitio Web</li>
            <li className="list">Proporcionarle una mejor experiencia en el uso del Sitio Web</li>
            <li className="list">Distinguirle de otros usuarios</li>
            <br />
            <br />
            Asimismo, solicitamos su consentimiento para utilizar cookies que nos permitan obtener más información acerca de sus
            preferencias y personalizar nuestro Sitio Web para ajustarlo a sus intereses.
         </TextStyled>
         <SubtitleStyled>4. ¿Cómo deshabilitar las cookies y eliminar las instaladas?</SubtitleStyled>
         <TextStyled>
            Puede usted permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del
            navegador instalado en su ordenador. Al desactivar cookies, algunos de los servicios disponibles podrían dejar de estar
            operativos.
            <br />
            <br />
            La forma de deshabilitar las cookies es diferente para cada navegador, pero normalmente puede hacerse desde el menú Herramientas
            u Opciones. También puede consultarse el menú de Ayuda del navegador dónde puedes encontrar instrucciones. El usuario podrá en
            cualquier momento elegir qué cookies quiere que funcionen en este sitio web.
            <br />
            <br />
            Estos son los enlaces de los distintos navegadores que informan sobre las cookies:
            <li>
               • Firefox:{" "}
               <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias">
                  https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias
               </a>
            </li>
            <br />
            <li>
               • Chrome:{" "}
               <a href="https://support.google.com/chrome/answer/95647?hl=es">https://support.google.com/chrome/answer/95647?hl=es</a>
            </li>
            <br />
            <li>
               • Explorer:{" "}
               <a href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies">
                  https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies
               </a>
            </li>
            <br />
            <li>
               • Safari:{" "}
               <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac">
                  https://support.apple.com/es-es/guide/safari/sfri11471/mac
               </a>
            </li>
            <br />
            <li>
               • Opera:{" "}
               <a href="http://help.opera.com/Windows/11.50/es-ES/cookies.html">http://help.opera.com/Windows/11.50/es-ES/cookies.html</a>
            </li>
         </TextStyled>
         <SubtitleStyled>5. Tipos de cookies: </SubtitleStyled>
         <TextStyled>
            Según quien sea la entidad que gestione el equipo o dominio desde donde se envían las cookies y trate los datos que se obtengan,
            podemos distinguir:
            <br />
            <br />
            <li>
               <b>• Cookies propias</b>: Son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio gestionado por
               el propio editor y desde el que se presta el servicio solicitado por el usuario.
            </li>
            <br />
            <li>
               <b>• Cookies de terceros</b>: Son aquéllas que se envían al equipo terminal del usuario desde un equipo o dominio que no es
               gestionado por el editor, sino por otra entidad que trata los datos obtenidos través de las cookies.
            </li>
            <br />
            Según la finalidad para la que se traten los datos obtenidos a través de las cookies, podemos distinguir entre:
            <br />
            <br />
            <li>
               <b>• Cookies técnicas</b>: Son aquéllas que permiten al usuario la navegación a través de una página web, plataforma o
               aplicación y la utilización de las diferentes opciones o servicios que en ella existan como, por ejemplo, controlar el
               tráfico y la comunicación de datos, identificar la sesión, acceder a partes de acceso restringido, recordar los elementos que
               integran un pedido, realizar el proceso de compra de un pedido, realizar la solicitud de inscripción o participación en un
               evento, utilizar elementos de seguridad durante la navegación, almacenar contenidos para la difusión de videos o sonido o
               compartir contenidos a través de redes sociales.
            </li>
            <li>
               <b> • Cookies de personalización</b>: Estas cookies almacenan información del comportamiento de los usuarios obtenida a
               través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para
               mostrar publicidad en función del mismo.
            </li>
            <li>
               <b>• Cookies de análisis</b>: Son aquéllas que bien tratadas por nosotros o por terceros, nos permiten cuantificar el número
               de usuarios y así realizar la medición y análisis estadístico de la utilización que hacen los usuarios del servicio ofertado.
               Para ello se analiza su navegación en nuestra página web con el fin de mejorar la oferta de productos o servicios que le
               ofrecemos.
            </li>
            <li>
               <b>• Cookies publicitarias</b>: Son aquéllas que, bien tratadas por nosotros o por terceros, nos permiten gestionar de la
               forma más eficaz posible la oferta de los espacios publicitarios que hay en la página web, adecuando el contenido del anuncio
               al contenido del servicio solicitado o al uso que realice de nuestra página web. Para ello podemos analizar sus hábitos de
               navegación en Internet y podemos mostrarle publicidad relacionada con su perfil de navegación.
            </li>
         </TextStyled>
      </>
   );
}

const TitleStyled = styled.p`
   color: ${Color.primary};
   font-weight: 200;
   font-size: 1.7em;
   margin-top: 3em;

   @media screen and (max-width: 1600px) {
      font-size: 1.4em;
   }
`;

const SubtitleStyled = styled.p`
   color: ${Color.primary};
   font-weight: 500;
   font-size: 1.1em;
   margin-top: 2em;

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
   }
`;
const TextStyled = styled.p`
   font-size: 1em;
   color: grey;
   margin-top: 0.5em;
   font-weight: 300;

   & a {
      color: inherit;
      text-decoration: underline;
   }

   & li {
      list-style: none;
      padding-left: 1em;
      margin: 0.5em 0;

      &.list {
         list-style: initial;
      }
   }

   & .blacklink {
      font-weight: 400;
   }

   @media screen and (max-width: 1600px) {
      font-size: 0.8em;
   }
`;
